import { createApi } from '@/api'
export default {
  orgList: config => createApi( `/org/pageSearch`, 'post', config ),
  orgDetail: config => createApi( `/org/get`, 'get', config ),
  deleteOrg: config => createApi( `/org/delete`, 'delete', config ),
  addOrg: config => createApi( `/org/add`, 'post', config ),
  updateOrg: config => createApi( `/org/update`, 'post', config ),
  orgType: config => createApi( `/org/orgType`, 'get', config ),
}



// WEBPACK FOOTER //
// ./src/views/orgManage/api/index.js